import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f392fd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "input_field" }
const _hoisted_3 = ["id", "name", "value", "placeholder", "inputmode", "aria-describedby"]
const _hoisted_4 = ["id"]

import { ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null,
    inputKey: null,
    title: null,
    placeholder: null,
    unit: null,
    inputPattern: null,
    inputMode: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', modelValue: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: string;
  inputKey: string;
  title: string;
  placeholder?: string;
  /** Unit of the entered value, shown inside the field, i.e. `K` */
  unit?: string;
  /** Characters a user may enter, everything else is rejected while typing */
  inputPattern?: RegExp;
  /** Keyboard a touch device offers, i.e. `numeric` or `decimal` */
  inputMode?: string;
  // TODO: maybe add type prop?
}





/**
 * Last accepted value, kept next to the prop as it is updated synchronously. The prop is only
 * applied on the next render, which can lag behind a fast typing user.
 */
const acceptedValue = ref(props.modelValue);

// The value can be set from the outside as well, i.e. by a form reset
watch(
  () => props.modelValue,
  (value) => {
    acceptedValue.value = value;
  },
);

const handleInput = (event: Event) => {
  const input = event.target as HTMLInputElement;

  // Undo a character the field does not accept, so a user cannot enter it in the first place
  if (props.inputPattern && !props.inputPattern.test(input.value)) {
    // Undoing moves the caret to the end, so put it back where the rejected input started. Its
    // length is the amount of characters the value grew by, which covers a pasted one as well.
    const rejectedLength = input.value.length - acceptedValue.value.length;
    const caret = Math.max(0, (input.selectionStart ?? 0) - rejectedLength);

    input.value = acceptedValue.value;
    input.setSelectionRange(caret, caret);
    return;
  }

  acceptedValue.value = input.value;
  emit('update:modelValue', input.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("label", {
      class: "f-w-b",
      for: __props.inputKey
    }, _toDisplayString(__props.title), 9, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        id: __props.inputKey,
        type: "text",
        name: __props.inputKey,
        class: _normalizeClass({ 'input_control--hasUnit': __props.unit }),
        value: __props.modelValue,
        placeholder: __props.placeholder,
        inputmode: __props.inputMode,
        "aria-describedby": __props.unit ? `${__props.inputKey}-unit` : undefined,
        onInput: handleInput
      }, null, 42, _hoisted_3),
      (__props.unit)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            id: `${__props.inputKey}-unit`,
            class: "input_unit"
          }, _toDisplayString(__props.unit), 9, _hoisted_4))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})